import React from 'react';
export var OptionsContext = /*#__PURE__*/React.createContext({});